/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_No_Event_SelectedInputs */



/**
* | output |
* | --- |
* | "No event selected. Please select an event first." |
*
* @param {Audio_Recorder_No_Event_SelectedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_no_event_selected = /** @type {((inputs?: Audio_Recorder_No_Event_SelectedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_No_Event_SelectedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun événement sélectionné. Veuillez d'abord sélectionner un événement.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es wurde keine Veranstaltung ausgewählt. Bitte wählen Sie zuerst eine Veranstaltung aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun evento selezionato. Seleziona prima un evento.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Мероприятие не выбрано. Пожалуйста, сначала выберите мероприятие.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se ha seleccionado ningún evento. Seleccione primero un evento.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("未选择任何活动。请先选择一个活动。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントが選択されていません。まずイベントを選択してください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई इवेंट नहीं चुना गया है। कृपया पहले एक इवेंट चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhum evento selecionado. Por favor, selecione um evento primeiro.")
	return /** @type {LocalizedString} */ ("No event selected. Please select an event first.")
});